import React, { useMemo, useState } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useIntl } from 'umi';

import FieldRow from './FieldRow';
import styles from './style.less';
import { isVisibleDetailField, splitHeroDetailFields } from './utils';

export { default as HeroDetailsAudit } from './Audit';
export {
  splitHeroDetailFields,
  isEmptyDetailValue,
  isVisibleDetailField,
  HERO_DETAIL_AUDIT_FIELD_NAMES,
  HERO_DETAIL_AUDIT_ROWS,
  resolveHeroDetailAuditUser,
  getHeroDetailSkeletonRows,
  getConfigFormSkeletonFields,
  getConfigFormSkeletonVariant,
  getConfigFormSkeletonRows,
  getHeroDetailSkeletonAuditCardCount,
} from './utils';

const HeroDetails = ({ data, showNull, className, includeAudit = false }) => {
  const { formatMessage } = useIntl();
  const [tooltip, setTooltip] = useState('');

  const copy = async (text, key) => {
    try {
      await navigator.clipboard.writeText(text.replace(/\s+/g, ''));
      setTooltip(key);
      setTimeout(() => setTooltip(''), 2000);
    } catch (e) {
      // Clipboard API may be unavailable
    }
  };

  const mainFields = useMemo(() => {
    if (includeAudit) {
      return (data || []).filter((item) => isVisibleDetailField(item, showNull));
    }
    return splitHeroDetailFields(data, showNull).mainFields;
  }, [data, showNull, includeAudit]);

  if (!mainFields.length) return null;

  return (
    <section className={classNames(styles.card, className)}>
      <dl className={styles.fieldList}>
        {mainFields.map((item, key) => (
          <FieldRow
            key={item.name || key}
            item={item}
            itemKey={key}
            formatMessage={formatMessage}
            styles={styles}
            tooltip={tooltip}
            onCopy={copy}
          />
        ))}
      </dl>
    </section>
  );
};

HeroDetails.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  showNull: PropTypes.bool,
  className: PropTypes.string,
  includeAudit: PropTypes.bool,
};

export default HeroDetails;
